import {
    apiRequest,
    masterRegion
} from "../../../../../services/adapters/kepegawaian/kursusService"

class RegionRepository {

    fetchRegion = async (query, cancelToken) => {
        return await apiRequest("get", masterRegion, {
            cancelToken: cancelToken,
            params: query
        }, true);
    }


    fetchRegionProvince = async (query) => {
        return await apiRequest("get", masterRegion, {
            params: query
        }, true)
    }

    fetchRegionCity = async (query) => {
        return await apiRequest("get", masterRegion, {
            params: query
        }, true)
    }
}

export default RegionRepository